export default __webpack_public_path__ + "static/media/placeholder_dummy2016-kuenstler02-de.f8e03408.png";